import React, { ReactNode } from 'react';
import { Text, Spacer } from '@koalafi/component-library';
import { useTrack } from '../../hooks/segment';
import Button from '../button/Button';
import Link from '../Link';

type PaymentSelectionBaseProps = {
  header: ReactNode;
  subText: ReactNode;
  primaryButtonText: string;
  primaryButtonAction: () => void;
  secondaryButtonAction: () => void;
  isLoading?: boolean;
  plaidRequired?: boolean;
};

const PaymentSelectionBase: React.FC<PaymentSelectionBaseProps> = ({
  header,
  subText,
  primaryButtonText,
  primaryButtonAction,
  secondaryButtonAction,
  isLoading = false,
  plaidRequired = false,
}) => {
  const track = useTrack();

  const secondaryButtonClasses =
    'text-accents-primary hover:bg-surface-secondary-container disabled:bg-transparent disabled:text-on-disabled disabled:opacity-60 p-[1rem 0]';
  const buttonBorder = 'w-full p-sm border-2 disabled:border-on-disabled border-accents-primary';
  const buttonTextClass = 'font-[Inter-SemiBold] text-[1rem] justify-center items-center cursor-pointer';
  const combinedStyles = `${secondaryButtonClasses} ${buttonBorder} ${buttonTextClass}`;

  const disclosureClick = () => {
    track('Plaid Authorization Disclosure');
    window.open('https://koalafi.com/plaid-authorization');
  };

  return (
    <div>
      {/* Header */}
      <Text size="3xl" alignText="left" weight="extrabold">
        {header}
      </Text>
      <Spacer size="md" />
      <Text size="md" alignText="left" weight="light">
        {subText}
      </Text>
      <Spacer size="lg" />
      <Button type="submit" onClick={primaryButtonAction} dataLoading={isLoading}>
        {primaryButtonText}
      </Button>
      {/* The Plaid Required feature flag hides the manual entry button so that customers must use the Plaid flow to enter banking information (OR-1345) 
          Once we validate that this is method of requiring Plaid is effective, we'll look into moving this out of a feature flag and into something
          more permanent, like a setting on a merchant */}
      {!plaidRequired && (
        <>
          <Spacer size="sm" />
          <button
            style={{ borderRadius: '0.625rem', fontFamily: 'Inter-SemiBold', fontSize: '1rem' }}
            className={combinedStyles}
            type="submit"
            onClick={secondaryButtonAction}
            data-testid="payment-selection-manual"
          >
            Enter bank info manually
          </button>
        </>
      )}
      <Spacer size="sm" />
      <Text size="sm" alignText="left" weight="light">
        {'By connecting with Plaid I consent to the '}
        <Link onClick={disclosureClick} linkText="Plaid Authorization" />
      </Text>
    </div>
  );
};

export default PaymentSelectionBase;
